export const useCheckAnswer = (userAnswer, answer, less, much, y) => {
  if (userAnswer > answer) return much;
  if (userAnswer < answer) return less;
  if (userAnswer === answer) return y;
};
